import isEqual from 'lodash/isEqual';

import type {
  AcornAction,
  AcornState,
  BananaAction,
  BananaState,
} from '@web-platform/shared-universal-types/src/redux/state/state-shared-types';
import type { Store, Dispatch } from 'redux';

const referenceComparator = <StateSlice>(state: StateSlice, nextState: StateSlice) =>
  isEqual(state, nextState);

// Implementation function that handles both cases
export function observeStore<
  State extends AcornState | BananaState,
  Action extends AcornAction | BananaAction,
  StateSlice,
>(
  store: Store<State, Action>,
  select: (state: State) => StateSlice,
  onChange: (
    getState: () => StateSlice,
    dispatch: Dispatch<Action>,
    _store: Store<State, Action>,
  ) => unknown,
  comparator: (state: StateSlice, nextState: StateSlice) => boolean = referenceComparator,
): () => void {
  let currentState: StateSlice;

  function handleChange() {
    const getNextState = () => select(store.getState());
    const nextState = getNextState();

    if (!comparator(currentState, nextState)) {
      currentState = nextState;
      onChange(getNextState, store.dispatch, store);
    }
  }

  const unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
}
